import {
  ReleaseStatusAlpha,
  ReleaseStatusAvailable,
  ReleaseStatusBeta,
  ReleaseStatusDeprecated,
  ReleaseStatusGa,
  ReleaseStatusNotAvailable,
  ReleaseStatusUnspecified,
} from '@weave/schema-gen-ts/dist/schemas/syncapp/integrations-service/integration.pb';
import { IconName } from '@frontend/icons';

export enum Verticals {
  DENTAL = 'Dental',
  ORTHO = 'Ortho',
  VET = 'Vet',
  OPTO = 'Opto',
  MEDICAL = 'Medical',
  MEDSPA = 'MedSpa',
  AUDIOLOGY = 'Audiology',
  ALL = 'All',
}

export const verticalsIconNameMap: Record<Verticals, IconName> = {
  [Verticals.DENTAL]: 'tooth',
  [Verticals.ORTHO]: 'bone',
  [Verticals.VET]: 'paw',
  [Verticals.OPTO]: 'view',
  [Verticals.MEDICAL]: 'medical-filled',
  [Verticals.MEDSPA]: 'hourglass',
  [Verticals.AUDIOLOGY]: 'support',
  [Verticals.ALL]: 'analytics',
};

export const verticalEntries: Array<{ vertical: Verticals; iconName: IconName }> = Object.values(Verticals).map(
  (vertical) => ({ vertical, iconName: verticalsIconNameMap[vertical] })
);

export enum Confirmation {
  YES = 'Yes',
  NO = 'No',
}

export enum FeatureStatus {
  SUPPORTED = 'Supported',
  NOT_SUPPORTED = 'Not Supported',
}

export enum FeatureStatusFilter {
  ALL = 'All',
  SUPPORTED = 'Supported',
  NOT_SUPPORTED = 'Unsupported',
}

export const featureStatusFilterIconNameMap: Record<FeatureStatusFilter, IconName> = {
  [FeatureStatusFilter.ALL]: 'analytics',
  [FeatureStatusFilter.SUPPORTED]: 'confirm-badge',
  [FeatureStatusFilter.NOT_SUPPORTED]: 'error-badge',
};

export const featureStatusFilterEntries: Array<{ filter: FeatureStatusFilter; iconName: IconName }> = Object.values(
  FeatureStatusFilter
).map((filter) => ({ filter, iconName: featureStatusFilterIconNameMap[filter] }));

export enum UserRole {
  ENGINEERING = 'ENGINEERING',
  SALES = 'SALES',
  SUPPORT = 'SUPPORT',
  PRODUCT = 'PRODUCT',
  ONBOARDING_CSM_SW = 'ONBOARDING_CSM_SW',
  LEADERSHIP = 'LEADERSHIP',
  ADMIN = 'ADMIN',
  ALL = 'ALL',
}

export enum IntegrationOverviewTab {
  FEATURES = 'Features',
  FAQS = "FAQ's",
  QUICK_LINKS = 'Quick Links',
  EXTERNAL_PARTNER_RESOURCES = 'External Partner Resources',
  PARTNER_INFORMATION = 'Partner Information',
  SUPPORTED_PMS_VERSIONS = 'Supported PMS Versions',
  OPERATING_SYSTEM = 'Operating System',
}

export enum PartnerInformationFields {
  PARENT_COMPANY = 'Parent Company',
  PARTNER_STATUS = 'Partner Status',
  PARTNER_INTEGRATION_STATUS = 'Partner Integration Status',
  AUTHORIZED_INTEGRATION_SINCE = 'Authorized Integration Since',
  PARTNER_DETAILS = 'Partner Details',
}

export enum IntegrationModalType {
  DELETE_CONFIRMATION = 'DELETE_CONFIRMATION',
  FAQ = 'FAQ',
  LINK = 'LINK',
  EDIT_PARTNER_INFORMATION = 'EDIT_PARTNER_INFORMATION',
  EDIT_OS_OR_PMS_VERSION = 'EDIT_OS_OR_PMS_VERSION',
  SUPPORTED_FEATURE = 'SUPPORTED_FEATURE',
  EDIT_SINGLE_FIELD = 'EDIT_SINGLE_FIELD',
}

export enum EditSingleFieldVariant {
  DESCRIPTION = 'description',
  VERTICALS = 'verticals',
  RELEASE_STATUS = 'releaseStatus',
  ROOT_NAME = 'rootName',
}

export const RELEASE_STATUS_OPTIONS = [
  { value: ReleaseStatusUnspecified, label: 'Unspecified' },
  { value: ReleaseStatusAvailable, label: 'Available' },
  { value: ReleaseStatusNotAvailable, label: 'Not Available' },
  { value: ReleaseStatusGa, label: 'GA' },
  { value: ReleaseStatusBeta, label: 'Beta' },
  { value: ReleaseStatusAlpha, label: 'Alpha' },
  { value: ReleaseStatusDeprecated, label: 'Deprecated' },
];

export const REQUEST_CHANGE_FORM_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSeuo6ntI6q_FeLQLr95c-Xh5SQTYmRfJa7TjoFWGJyaVp8hMQ/viewform?usp=header';
